const fetchConversations = (state, action) => {
  const { status } = action;
  switch (status) {
    case 'started': {
      return {
        ...state,
        fetchingConversations: true,
      };
    }
    case 'success': {
      const {
        payload: { conversations, totalCount },
      } = action;
      return {
        ...state,
        fetchingConversations: false,
        totalCount,
        paginatedConversationIds: conversations.map((c) => c.id),
        conversationHasOlderMessages: conversations.reduce(
          (acc, { id }) => ({
            ...acc,
            [id]: true,
          }),
          {}
        ),
      };
    }
    case 'error': {
      return {
        ...state,
        fetchingConversations: false,
      };
    }
    default:
      return state;
  }
};

export default fetchConversations;
